// extracted by mini-css-extract-plugin
export default {"root":"ChatId_root__SSPnj","header":"ChatId_header__7U61l","box":"ChatId_box__OKH1k","menu":"ChatId_menu__ec1Q6","body":"ChatId_body__-v4m2"};